import { makeAutoObservable } from "mobx"

import {
  ReportStatus,
  ReportData,
  ReportETA,
  WorkbookReportEntity,
} from "@framework/types/workbook-report"
import AnswerFeedbackStore from "@store/search/answer-feedback.store"
import { DEFAULT_FEEDBACK_RATING } from "@framework/constants/search-results"

const defaultEta = {
  minTimeInSec: 5,
  maxTimeInSec: 10,
}

export default class WorkbookReportStore {
  readonly id: string

  data: ReportData | null = null

  createdAt: string | null = null

  updatedAt: string | null = null

  eta: ReportETA

  status: ReportStatus

  isLoading: boolean = false

  error: string | null = null

  createdById?: string

  feedback: AnswerFeedbackStore

  constructor(id: string) {
    this.id = id
    this.eta = { ...defaultEta }
    this.status = "in-progress"
    this.feedback = new AnswerFeedbackStore({
      rating: DEFAULT_FEEDBACK_RATING,
      reason: "",
    })

    makeAutoObservable(this)
  }

  update = (data: WorkbookReportEntity) => {
    this.data = data.documentText
    this.status = data.status
    this.createdAt = data.createdAt
    this.updatedAt = data.updatedAt
    this.createdById = data.userId
    this.eta = { ...defaultEta, ...data.eta }

    if (data.rating != null)
      this.feedback = new AnswerFeedbackStore({
        rating: data.rating,
        reason: data.comment ?? "",
        editable: data.rating === DEFAULT_FEEDBACK_RATING && !data.comment,
      })
  }

  setFeedback = (feedbackStore: AnswerFeedbackStore) => {
    this.feedback = feedbackStore
    return feedbackStore
  }
}
